export var ModalContainerLoadsheet = {
	container: null,
	init: function (idDiv) {
		this.container = document.querySelector("#" + idDiv);
		if (!this.container) {
			this.container = document.createElement("div");
			this.container.id = idDiv;
			this.container.hidden = true;
			document.body.appendChild(this.container);

			m.mount(this.container);
		}
	},
	open: function (sourceDiv) {
		if (this.container === null)
			this.container = document.querySelector("#" + idDiv);
		else {
			const newDiv = document.createElement("div");
			newDiv.classList.add("dm-overlay", "loadsheet-modal");

			this.container.appendChild(newDiv);
			newDiv.appendChild(sourceDiv);



			this.container.hidden = false;
			m.redraw.strategy("diff");
		}
	},
	close: function () {
		this.container.hidden = true;
        const data = this.container.querySelector(".dm-overlay");
        data.remove();
	},
};

var ModalViewrLoadsheet = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay", this.container)];
    }
};
